export default function toggleAttribute(element, name, set) {
  if (set) {
    element.setAttribute(name, "")
  } else {
    element.removeAttribute(name)
  }
}
